import { render, staticRenderFns } from "./inputGosokCapKwi.vue?vue&type=template&id=4b45011a&"
import script from "./inputGosokCapKwi.vue?vue&type=script&lang=js&"
export * from "./inputGosokCapKwi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports